import clsx from 'clsx';
import { useSelect } from 'downshift';
import React from 'react';

import { Button } from '../Button';
import { BodyText } from '../Typography/BodyText';

export type JobCardButtonDropdownProps = {
  /**
   * The list of items to render in the dropdown.
   */
  items: Array<
    {
      text: string;
    } & (
      | {
          href: string;
          onClick?: never;
        }
      | {
          href?: never;
          onClick: React.MouseEventHandler<HTMLDivElement>;
        }
    )
  >;
};

export const JobCardButtonDropdown = ({ items }: JobCardButtonDropdownProps): JSX.Element => {
  const { isOpen, getToggleButtonProps, getLabelProps, getMenuProps, getItemProps } = useSelect({
    items,
  });
  return (
    <div>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control -- the props added from downshift correctly associates the label and the button with `for` and `id` */}
      <label {...getLabelProps()} aria-label="job card menu">
        <Button variant="secondary" icon="ellipseHorizontal" {...getToggleButtonProps()} />
      </label>
      <ul
        className={clsx(`absolute right-0 w-[235px] overflow-auto rounded-8 bg-white drop-shadow`, {
          hidden: !isOpen,
        })}
        {...getMenuProps()}
      >
        {isOpen &&
          items.map((item, index) => (
            <li key={`${item.text}_${index}`} {...getItemProps({ item, index })}>
              {React.createElement(
                item.href ? 'a' : 'div',
                {
                  className: 'cursor-pointer p-12 hover:bg-gray',
                  ...(item.href ? { href: item.href } : { onClick: item.onClick }),
                },
                <BodyText>{item.text}</BodyText>,
              )}
            </li>
          ))}
      </ul>
    </div>
  );
};
